import { Button } from '@mui/material';
import * as React from 'react';

interface Props {
  onClick: () => void;
}

export const AddCredential: React.FC<Props> = (props) => {
  return (
    <Button variant="contained" onClick={props.onClick}>
      <h4>+ Add credential</h4>
    </Button>
  );
};
AddCredential.displayName = 'AddCredential';
